import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PhotoLoaderModule } from '../loader/photo-loader.module';
import { PhotoValidationService } from './photo-validation.service';

@NgModule({
    imports: [CommonModule, PhotoLoaderModule],
    declarations: [],
    providers: [PhotoValidationService],
    exports: []
})
export class PhotoValidationModule {}
